/** 複製連結 */
export const copyText = async (copyValue) => {
    if (navigator && navigator.clipboard) {
        return navigator.permissions.query({ name: "clipboard-write" }).then((permissionStatus) => {
            if (permissionStatus.state === "granted") {
                return navigator.clipboard
                    .writeText(copyValue)
                    .then(() => {
                        return;
                    })
                    .catch(function (e) {
                        console.error("複製失敗", e);
                    });
            } else {
                console.error("複製失敗");
            }
        });
    } else {
        console.error("複製失敗");
    }
};

export const checkElementVisibleByID = (id) => {
    if (!id) {
        return false;
    }
    const el = document.getElementById(id.startsWith("#") ? id.substring(1) : id);
    if (!el) {
        return false;
    }
    return checkElementVisible(el);
};

export const checkElementVisible = (el) => {
    if (!el) {
        return false;
    }
    let current = el;
    while (current) {
        const style = window.getComputedStyle(current);
        if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0" || current.hasAttribute("hidden")) {
            return false;
        }
        current = current.parentElement;
    }
    return el.offsetWidth > 0 && el.offsetHeight > 0;
};

export const linkify = (text) => {
    if (!text) {
        return text;
    }
    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/gi;
    return text.replace(urlRegex, (url) => {
        let hyperlink = url;
        if (!hyperlink.startsWith("http")) {
            hyperlink = "http://" + hyperlink;
        }
        return `<a class="underline" href="${hyperlink}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
};

export const loadScript = (src) => {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve(); // 已存在，不需載入
            return;
        } else {
            const script = document.createElement("script");
            script.src = src;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = (err) => reject();
            document.head.appendChild(script);
        }
    });
};
